import { render, staticRenderFns } from "./image-crop.vue?vue&type=template&id=3f0c97b4&"
import script from "./image-crop.vue?vue&type=script&lang=js&"
export * from "./image-crop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports